import { httpCreate } from './http';

const http = httpCreate('/um/tag');

export const umTag = {
	getList(params) {
		return http.get(`/pageList`, { params });
	},
	getTotalTagList(params) {
		return http.get(`/list`, { params });
	},
	create(body) {
		return http.post(``, body);
	},
	update(body) {
		return http.put(``, body);
	},
	changeStatus(id, status) {
		return http.put(`/status/${id}/${status}`);
	},
	remove(id) {
		return http.delete(`/${id}`);
	},
};
